<template>
  <div class="d-flex">
    <v-btn
      v-if="actions.length"
      class="mr-2"
      depressed
      color="primary"
      @click="makeAction"
    >
      Podejmij działanie
    </v-btn>

    <v-btn
      v-if="downloadReportPermitted"
      class="mr-2"
      depressed
      color="secondary"
      @click="$emit('print-report')"
    >
      Pobierz raport
    </v-btn>

    <v-btn
      v-if="metricsPermitted"
      class="mr-4"
      depressed
      color="secondary"
      link
      :to="{ name: 'project-metrics', params: { id: project.id } }"
    >
      Metryka
    </v-btn>

    <v-btn
      v-if="isEditable"
      class="mr-2"
      depressed
      color="primary"
      link
      :to="{ name: 'project-edit', params: { id: project.id } }"
    >
      Edycja
    </v-btn>

    <v-btn
      v-if="deletePermitted"
      depressed
      color="primary"
      @click="$emit('delete', project.id)"
    >
      Usuń
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapState('auth', [
      'user',
    ]),
    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),
    isEditable() {
      const { editable, softDeleted, locationEditable, printCoordinationEditable } = this.project;
      return (editable || printCoordinationEditable || locationEditable) && !softDeleted;
    },
    deletePermitted() {
      const { userId, status } = this.project;
      const isOwnDraft = status === 'Wersja robocza' && userId === this.user.id;
      const availability = ['admin_director', 'chief'];
      return isOwnDraft || this.checkUserPermissions(availability);
    },
    metricsPermitted() {
      const availability = ['admin_director', 'chief', 'department_director', 'user',
        'graphic', 'editor', 'project_manager', 'print_coordinator', 'other'];
      return this.checkUserPermissions(availability);
    },
    downloadReportPermitted() {
      const availability = ['admin_director', 'chief', 'graphic', 'editor', 'project_manager', 'print_coordinator', 'other'];
      return this.checkUserPermissions(availability);
    },
  },

  methods: {
    ...mapActions('dialog', [
      'showDialog',
    ]),

    makeAction() {
      let graphicRevision = false;
      const { id, status, files } = this.project;
      if (this.checkUserPermissions(['graphic']) && status === 'Zespół projektowy skompletowany') {
        graphicRevision = true;
      }
      this.showDialog({
        header: 'Potwierdzenie działania',
        text: 'Masz do podjęcia działania w projekcie.',
        component: 'MakeAction',
        props: {
          id,
          files,
          graphicRevision,
          actions: this.actions,
          width:640
        },
      });
    },
  },
};
</script>
